import { version } from 'Config'

import {
  TERMS_AND_CONDITIONS, PRIVACY_POLICY, STATUS, ZENQMSLLC,
} from '@/constants'

import './Footer.scss'

const Footer = () => (
  <div className="footer-wrapper">
    <footer>
      <div className="button-container">
        <a href="mailto:help@zenqms.com?subject=ZenQMS Homepage Help Request">
          <button type="button" data-testid="footer-support">Support</button>
        </a>
      </div>
      <ul className="footer-info">
        <li className="footer-company">
          <a
            data-testid="footer-company"
            href={ZENQMSLLC}
            target="_blank"
            rel="noopener noreferrer"
          >
            © ZenQMS LLC
          </a>
        </li>
        <li>
          <a
            data-testid="footer-terms"
            href={TERMS_AND_CONDITIONS}
            target="_blank"
            rel="noopener noreferrer"
            className="login-footer-link"
          >
            Terms
          </a>
        </li>
        <li className="footer-dot" aria-hidden="true" />
        <li>
          <a
            data-testid="footer-privacy"
            href={PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
            className="login-footer-link"
          >
            Privacy
          </a>
        </li>
        <li>&amp;</li>
        <li>
          <a
            data-testid="footer-status"
            href={STATUS}
            target="_blank"
            rel="noopener noreferrer"
            className="login-footer-link"
          >
            Status
          </a>
        </li>
        <li className="footer-version" data-testid="footer-version">
          <span className="footer-dot" aria-hidden="true" />
          {version}
        </li>
      </ul>
    </footer>
  </div>
)

export default Footer
